export default {
  float: [
    // general
    'min_beds',
    'max_beds',
    'min_baths',
    'max_baths',

    // financial calculator
    'asking_price',
    'annual_rent_increase',
    'annual_expense_increase',
    'cap_ex_amt',
    'cash_flow',
    'cash_on_cash',
    'closing_costs',
    'current_value',
    'estimated_rent',
    'insurance_costs',
    'maintenance_costs',
    'property_taxes',
    'rent_amt',
    'vacancy_amt',
    'management_costs',
    'hoa_dues',
    'hpa_avg',
  ],
  pct: [
    // financials
    'min_gross_yield',
    'max_gross_yield',
    'min_net_yield',
    'max_net_yield',
    'min_expense_load',
    'max_expense_load',
    'min_hpa',
    'max_hpa',

    //financial calculator
    'maintenance_rate',

  ],
  int: [
    // general
    'min_asking_price',
    'max_asking_price',
    'min_year_built',
    'page',
        
    // financials
    'min_monthly_rent',
    'max_monthly_rent',

    // Size
    'min_sqft',
    'max_sqft',
    'min_lot_size',
    'max_lot_size',

  ],
  bool: [
    // other
    // 'leased_properties_only',
    'section8',
        
    // amenities
    'has_dining_area',
    'has_high_ceilings',
    'has_ceiling_fans',
    'has_walk_in_closets',
    'has_granite_countertops',
    'has_satellite_tv',
    'has_cable_ready',
    'has_fireplace',
    'has_storage',
    'has_indoor_jacuzzi',
    'has_views',
    'has_ceramic_tile',
    'has_hardwood_floors',
    'has_new_carpet',
    'has_washer',
    'has_dryer',
    'has_stainless_steel_appliances',
    'has_eat_in_kitchen',
    'has_oven_range',
    'has_garbage_disposal',
    'has_refrigerator',
    'has_stove',
    'has_dishwasher',
    'has_microwave',
    'has_ac',
    'has_central_heating',
  ],
  arr: [
    'selected_zipcodes'
  ],
  str: [
    'match_type'
  ]
};